import { render, staticRenderFns } from "./kabupaten.vue?vue&type=template&id=55773bf4"
import script from "./kabupaten.vue?vue&type=script&lang=js"
export * from "./kabupaten.vue?vue&type=script&lang=js"
import style0 from "./kabupaten.vue?vue&type=style&index=0&id=55773bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports